import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function LegalModal({
  title,
  content,
  onClose
}: {
  title: string;
  content: React.ReactNode;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-85">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-87">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-[#1B2A4A]" data-id="element-88">
            <h2 className="text-xl font-bold text-white font-serif" data-id="element-89">{title}</h2>
            <button onClick={onClose} className="text-gray-300 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-90">
              <XIcon className="w-6 h-6" data-id="element-91" />
            </button>
          </div>
          <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-92">
            {content}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
const privacyContent = <>
    <p className="text-xs text-gray-500" data-id="element-93">Última actualización: Abril 2026</p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-94">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-95">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      entregar el producto digital, incluyendo tu nombre y dirección de correo
      electrónico.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-96">
      2. Uso de la Información
    </h3>
    <p data-id="element-97">
      Tu información se utiliza exclusivamente para: enviar el producto digital
      adquirido, comunicar actualizaciones importantes del material, y mejorar
      nuestros servicios.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-98">
      3. Protección de Datos
    </h3>
    <p data-id="element-99">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal. No almacenamos datos de tarjetas de crédito;
      todos los pagos son procesados por plataformas de pago seguras de
      terceros.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-100">
      4. Compartir Información
    </h3>
    <p data-id="element-101">
      No vendemos, intercambiamos ni transferimos tu información personal a
      terceros. La única excepción son los proveedores de servicios de confianza
      que nos asisten en la operación del sitio web y el procesamiento de pagos.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-102">5. Cookies</h3>
    <p data-id="element-103">
      Nuestro sitio puede utilizar cookies para mejorar la experiencia del
      usuario. Puedes configurar tu navegador para rechazar cookies, aunque esto
      podría afectar algunas funcionalidades.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-104">6. Tus Derechos</h3>
    <p data-id="element-105">
      Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
      personales en cualquier momento.
    </p>
  </>;
const termsContent = <>
    <p className="text-xs text-gray-500" data-id="element-106">Última actualización: Abril 2026</p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-107">
      1. Naturaleza del Producto
    </h3>
    <p data-id="element-108">
      Este es un producto educativo digital. No constituye asesoría legal,
      migratoria ni de inmigración. Para asuntos legales, consulta con un
      abogado de inmigración licenciado.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-109">2. Producto Digital</h3>
    <p data-id="element-110">
      Al completar la compra, recibirás acceso inmediato al material digital
      (PDF + Bundle). Debido a la naturaleza digital del producto, todas las
      ventas son finales.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-111">3. Uso Permitido</h3>
    <p data-id="element-112">
      El material adquirido es para uso personal y exclusivo del comprador.
      Queda prohibida la reproducción, distribución, reventa o compartición del
      contenido sin autorización expresa por escrito.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-113">
      4. Propiedad Intelectual
    </h3>
    <p data-id="element-114">
      Todo el contenido, incluyendo textos, diseños, gráficos y metodologías,
      está protegido por derechos de autor. El Método de Traducción Espejo y
      Anclaje Visual es propiedad exclusiva de Ciudadanía USA: Guía Exprés.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-115">
      5. Limitación de Responsabilidad
    </h3>
    <p data-id="element-116">
      No garantizamos resultados específicos en el examen de ciudadanía. El
      éxito depende del esfuerzo individual del usuario. No nos hacemos
      responsables por decisiones tomadas basándose en este material educativo.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-117">6. Actualizaciones</h3>
    <p data-id="element-118">
      Nos reservamos el derecho de actualizar estos términos en cualquier
      momento. Las actualizaciones serán efectivas al momento de su publicación.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="w-full bg-[#1B2A4A] text-white" data-id="element-119">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-120">
          <div className="text-center space-y-6" data-id="element-121">
            <div className="max-w-4xl mx-auto bg-white/5 p-6 rounded-lg border border-white/10" data-id="element-122">
              <p className="text-sm text-gray-300 leading-relaxed" data-id="element-123">
                <strong className="text-white" data-id="element-124">⚠️ AVISO LEGAL:</strong> Esta
                guía es un producto educativo independiente. No está afiliada,
                patrocinada ni aprobada por USCIS ni por ninguna agencia del
                gobierno de los Estados Unidos. No constituye asesoría legal de
                inmigración. Para casos legales específicos consulte a un
                abogado de inmigración certificado.
              </p>
            </div>

            <div className="flex items-center justify-center gap-4" data-id="element-125">
              <button onClick={() => setActiveModal('privacy')} className="text-sm text-[#C9A84C] hover:text-[#d4b35c] transition-colors underline underline-offset-2" data-id="element-126">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-127">|</span>
              <button onClick={() => setActiveModal('terms')} className="text-sm text-[#C9A84C] hover:text-[#d4b35c] transition-colors underline underline-offset-2" data-id="element-128">
                Términos y Condiciones
              </button>
            </div>
            <p className="text-sm text-gray-400" data-id="element-129">
              © 2026 Ciudadanía USA: Guía Exprés. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {activeModal === 'privacy' && <LegalModal title="Política de Privacidad" content={privacyContent} onClose={() => setActiveModal(null)} data-id="element-130" />}
      {activeModal === 'terms' && <LegalModal title="Términos y Condiciones" content={termsContent} onClose={() => setActiveModal(null)} data-id="element-131" />}
    </>;
}